import { Select } from '@mantine/core'

interface DropdownProps {
  value: string
  onChange: (value: string) => void
}

const Dropdown = ({ value, onChange }: DropdownProps) => {
  return (
    <Select
      placeholder="Level"
      data={[
        { value: 'A', label: '전체' },
        { value: '1', label: 'level 1' },
        { value: '2', label: 'level 2' },
        { value: '3', label: 'level 3' },
        { value: '4', label: 'level 4' },
        { value: '5', label: 'level 5' },
        { value: '6', label: 'level 6' },
        { value: '7', label: 'level 7' },
        { value: '8', label: 'level 8' },
        { value: '9', label: 'level 9' },
        { value: '10', label: 'level 10' },
        { value: '11', label: 'level 11' },
        { value: '12', label: 'level 12' },
        { value: '99', label: 'level 99' },
      ]}
      value={value}
      onChange={(val) => onChange(val || '')}
    />
  )
}

export default Dropdown
